<template>
  <div class="pc-tag">
    <h1 class="pc-tag-head">用户标签</h1>
    <div class="pc-tag-labels">
      <el-tag
        :style="
          'background:' +
          colorBox[index] +
          ';color:white;border:none;padding-top:1.5px;'
        "
        :class="{ hideCrucifix: isHideCrucifix, activeNone: !tag }"
        :key="index"
        v-for="(tag, index) in dynamicTags"
        closable
        :disable-transitions="false"
        @close="handleClose(tag)"
      >
        {{ tag }}
      </el-tag>
    </div>
  </div>
</template>



<script>
export default {
  props: { userDetail: Object },
  watch: {
    userDetail: function () {
      this.dynamicTags = [];
      if (this.userDetail.tags) {
        this.userDetail.tags.forEach((item, i, arr) => {
          this.dynamicTags.push(item.name);
        });
      }
    },
  },
  data() {
    return {
      isHideCrucifix: true,
      dynamicTags: [],
      colorPool: [
        ["#5470C6", "#91CC75"],
        ["#FAC858", "#EE6666"],
      ],
      colorBox: [],
    };
  },
  created() {
    this.generateColorBox();
  },
  methods: {
    generateColorBox() {
      let _arr = new Array(100).fill("red");
      _arr.forEach((item, i, arr) => {
        if (i % 2 == 0) {
          arr[i] = this.colorPool[0][
            Math.floor(Math.random() * this.colorPool[0].length)
          ];
        } else {
          arr[i] = this.colorPool[1][
            Math.floor(Math.random() * this.colorPool[1].length)
          ];
        }
      });
      this.colorBox = _arr;
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-tag {
  display: inline-block;
  vertical-align: top;
  padding: 30px 30px 0 30px;
  height: 270px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  .pc-tag-head {
    padding-bottom: 15px;
    border-bottom: 1px solid $border-color;
    font-family: $chinese;
    font-size: 20px;
    font-weight: 600;
    color: $mainTitle;
    position: relative;
    button {
      position: absolute;
      right: 0;
      top: -7px;
      width: 90px;
      height: 30px;
      background: $blueBtna;
      border-radius: 4px;
      border: none;
      outline: none;
      font-family: $chinese;
      font-size: 14px;
      font-weight: 400;
      color: white;
      cursor: pointer;
    }
  }

  // 滚轴
  .pc-tag-labels::-webkit-scrollbar-thumb {
    background-clip: content-box !important;
    border-left: 2px solid transparent;
    border-right: 2.5px solid transparent;
    border-top: 3px solid transparent;
    border-bottom: 3px solid transparent;
    border-radius: 100px;
    background-color: $lightenGreya;
  }
  .pc-tag-labels::-webkit-scrollbar-button {
    display: none;
  }
  .pc-tag-labels::-webkit-scrollbar {
    width: 12px;
    border: $bordertabled;
  }
  // end 滚轴
  .pc-tag-labels {
    margin-top: 20px;
    height: 160px;
    overflow-y: auto;
    .activeNone {
      display: none;
    }
    .hideCrucifix {
      /deep/ .el-tag__close.el-icon-close {
        display: none !important;
      }
    }
    /deep/ .el-tag {
      margin-right: 10px !important;
      margin-bottom: 10px !important;
      font-size: 14px;
      min-width: 90px;
      text-align: center;
    }
    /deep/ .el-tag + .el-tag {
      margin-left: 0 !important;
    }
    /deep/ .button-new-tag {
      margin-left: 0;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }
    /deep/ .input-new-tag {
      width: 90px;
      margin-left: 0;
      vertical-align: bottom;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userDetail/UserTag.vue